var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography } from '@mui/material';
export var SimpleSection = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, style = _a.style, children = _a.children;
    return (_jsxs(Box, __assign({ sx: { width: '100%' }, style: __assign({}, style) }, { children: [title && (_jsx(Typography, __assign({ variant: "h5", gutterBottom: true }, { children: title }))), subTitle && (_jsx(Typography, __assign({ variant: "subtitle1", gutterBottom: true, align: "center" }, { children: subTitle }))), _jsx(Box, { children: children })] })));
};
export default SimpleSection;
